import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

const StyledLicenseInfo = styled(Box)(({ theme }) => ({
  "& .header": {
    display: "flex",
    borderRadius: 0,
    borderBottomColor: theme.palette.primary.dark,
    borderBottomStyle: "solid",
    borderBottomWidth: 3,
    overflowX: "auto",
    padding: "1rem 0",
    backgroundColor: "transparent",
    ...theme.applyStyles("light", { borderBottomColor: "#76c836" }),
  },
  "& .container": {
    margin: "0 0.5em",
  },
  "& .icon": {
    display: "flex",
    padding: "0.625rem",
    alignItems: "center",
    justifyContent: "center",
    '& .MuiSvgIcon-root:not([aria-label="Expired"])': { color: "#76c836" },
  },
  "& .flex-col": {
    display: "flex",
    flexDirection: "column",
  },
  "& .label": {
    marginRight: "0.5em",
  },
  "& .text": {
    fontWeight: "normal",
    color: "white",
    ...theme.applyStyles("light", { color: "#000" }),
  },
  "& .bold": {
    fontWeight: 600,
    color: "white",
    ...theme.applyStyles("light", { color: "#6a6969" }),
  },
  "& .dark": {
    fontWeight: 600,
    color: "white",
    ...theme.applyStyles("light", { color: "#6a6969" }),
  },
  "& .light": {
    lineHeight: 1,
    fontSize: "0.9rem",
    fontWeight: 500,
    color: "white",
    ...theme.applyStyles("light", { color: "#767676" }),
  },
  "& .left-column": {},
  "& .right-column": {
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
    height: "100%",
  },
}));
export default StyledLicenseInfo;
